import { render, staticRenderFns } from "./alerts.vue?vue&type=template&id=79ae0f75&"
import script from "./alerts.vue?vue&type=script&lang=js&"
export * from "./alerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports